module.exports = {"name":"pluginNewCalendar","audiences":["alphaMembers"],"experimentAllocation":1,"defaultWeight":0,"experimentVersion":"v1","defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/pluginNewCalendar.json
// module id = ooRz
// module chunks = 1